import { clearImgData, getMyModuleServer, removeAIModules } from "common-lib";
import { AI_SERVER_DISCONNECTED_EVENT } from "./client";

// 학습 옵션 모달을 열면 연결 확인(ensureAIServer) → 옵션 로드 → 미리보기 준비가 같은 /modules/server를 연달아 부른다.
// 읽기만 잠깐 공유하고, /sync로 모듈을 바꾸면(useAIModuleSync) 바로 버린다
// ponytail: 짧은 TTL + 쓰기 무효화. 여기를 거치지 않는 updateAIModules 호출(ImagePart 등)은 모달과 동시에 일어나지 않는다
const TTL = 2000;
const cache = new Map<string, { at: number; p: Promise<any> }>();

export const fetchModuleServer = (specId?: string | null) => {
  const key = String(specId);
  const hit = cache.get(key);
  if (hit && Date.now() - hit.at < TTL) return hit.p;

  const p = getMyModuleServer(specId, null).catch((error: any) => {
    cache.delete(key);
    throw error;
  });
  cache.set(key, { at: Date.now(), p });
  return p;
};

export const invalidateModuleServer = () => cache.clear();

export const ensureAIServer = async (specId?: string | null) => {
  try {
    const { module, serverAddress } = await fetchModuleServer(specId);
    if (module && serverAddress) return true;
  } catch (error) {
    console.error("ensureAIServer:", error);
  }
  window.dispatchEvent(new CustomEvent(AI_SERVER_DISCONNECTED_EVENT));
  return false;
};

// 프로젝트에 import된 AI 모듈을 서버에서 내린다
export const removeImportedModules = async (p: { id: number; step?: string; class?: string[] }) => {
  const uuids = p.step === "분석" ? [...(p.class ?? []), "ETC"].map((c) => `${p.id}_${c}`) : [`${p.id}`];
  await Promise.all(
    uuids.map(async (uuid) => {
      const { module, serverAddress } = await fetchModuleServer(uuid);
      if (!module || !serverAddress) return;
      await clearImgData(serverAddress, uuid);
      await removeAIModules(serverAddress, uuid);
    }),
  );
  invalidateModuleServer();
};
